import { render, staticRenderFns } from "./FirmType.vue?vue&type=template&id=5ccbbc2d&"
import script from "./FirmType.vue?vue&type=script&lang=js&"
export * from "./FirmType.vue?vue&type=script&lang=js&"
import style0 from "./FirmType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports